export default __webpack_public_path__ + "static/media/Settings-2.cd535a83.svg";